<app-embedded-toolbar (onConfigure)="scope.openConfiguration()" [configurationName]="scope.translations.DASHBOARD_CONFIG"></app-embedded-toolbar>
<div class="dashboard-hero">
    <div class="dashboard-hero__inner">
        <h1 class="dashboard-hero__title" [innerText]="scope.getText | transform:'DASHBOARD'"></h1>
    </div>
</div>
<div class="dashboard-body">
    <app-error-summary [error]="scope.error" *ngIf="scope.error"></app-error-summary>
    <app-panels [suggestedJobsOpen]="scope.suggestedJobsOpen"></app-panels>
</div>
